export default function VPNService() {
  const services = [
    {
      icon: 'ri-lock-line',
      title: 'Military Encryption',
      description: 'AES-256 bit encryption ensures your data remains completely secure and private. The same level of security used by governments and financial institutions worldwide.',
      color: 'bg-[#00D9FF]'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access our worldwide infrastructure with servers strategically located across multiple continents, ensuring fast and reliable connections wherever you are.',
      color: 'bg-purple-500'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast',
      description: 'Experience blazing-fast speeds with our optimized network architecture. Stream, download, and browse without any lag or buffering delays.',
      color: 'bg-[#0066FF]'
    }
  ];

  return (
    <section id="vpn-service" className="py-32 bg-gradient-to-b from-white to-[#FAFCFF]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#0A1628] mb-4">
            Enterprise-Grade VPN Technology
          </h2>
          <div className="w-16 h-1 bg-[#00D9FF] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className={`w-20 h-20 ${service.color} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#0A1628] mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
